/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Left_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Align text left" |
*
* @param {Align_Left_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_left_aria_label = /** @type {((inputs?: Align_Left_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Left_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aligner le texte a gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text linksbündig ausrichten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Allinea il testo a sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выравнивание текста по левому краю")
	if (locale === "es") return /** @type {LocalizedString} */ ("Alinear el texto a la izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文本左对齐")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキストを左揃えにする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट को बाईं ओर संरेखित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alinhar texto à esquerda")
	return /** @type {LocalizedString} */ ("Align text left")
});